var styles = {"link":"Thumb_link_cz3os_62","open":"Thumb_open_cz3os_81","icon-container":"Thumb_icon-container_cz3os_88","arrow":"Thumb_arrow_cz3os_103","simple":"Thumb_simple_cz3os_116","active":"Thumb_active_cz3os_120","hovered":"Thumb_hovered_cz3os_120"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
